import { render, staticRenderFns } from "./CustomStyleDemo.vue?vue&type=template&id=58432e4e"
import script from "./CustomStyleDemo.vue?vue&type=script&lang=js"
export * from "./CustomStyleDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports